import api from '.';

export interface QueryStaticEquipmentAccessory {
  projectId: number;
  plant: string | null;
  area: string | null;
  staticEquipmentLists: {
    staticEquipmentListId: number;
    quantity: number | null;
    staticAccessoryLists?: {
      staticAccessoryListId: number;
      quantity: number | null;
    }[];
  }[];
}

export async function getStaticEquipmentLists() {
  const { data } = await api.get('/static-equipment-lists');

  return data;
}

export async function queryStaticEquipmentAccessoryWithDocuments(
  queryStaticEquipmentAccessory: QueryStaticEquipmentAccessory
) {
  const { data } = await api.post(
    '/static-equipment-lists/bulk-planning',
    queryStaticEquipmentAccessory
  );

  return data;
}
